<div class="screening-tool page">

    <div class="screening-tool__background"></div>
    <!-- Exit -->
    <div class="overlay-block overlay-block--top">
        <img class="tool-logo" (click)="routeTo('home', CloseType.SiteLogo)" src="assets/logos/logo-screen-for-epi.svg" alt="">
        <div class="horizontal-block">
            <p class="label">Exit</p>
            <div class="tool-button circle-button" (click)="routeTo('home', CloseType.Button)">
                <img src="assets/icons/icon-x.svg" alt="">
            </div>
        </div>
    </div>
    <!-- Question and Answer buttons -->
    <div *ngIf="currentQuestion" class="screening">
        <h3 class="screening__question">{{ currentQuestion.question }}</h3>
        <div class="screening__c-button">
            <div class="screening__button">
                <app-button [variation]="answer !== 'yes' ? 'button--white' : '' " text="Yes" (btnClick)="questionToggle('yes')" ></app-button>
            </div>
            <div class="screening__button">
                <app-button [variation]="answer !== 'no' ? 'button--white' : '' " text="No" (btnClick)="questionToggle('no')"></app-button>
            </div>
            <div *ngIf="currentQuestion.unknown" class="screening__button unknown">
                <app-button [variation]="answer !== 'unknown' ? 'button--white' : '' " text="Unknown" (btnClick)="questionToggle('unknown')"></app-button>
            </div>
        </div>
        <app-button *ngIf="answer && answer !== ''" text="Continue" icon="assets/icons/icon-arrow-forward.svg" class="continue-btn" (btnClick)="answerQuestion()"></app-button>
    </div>
    <!-- Missing These Data? -->
    <div class="overlay-block overlay-block--bottom">
        <div class="horizontal-block" *ngIf="!currentQuestion?.unknown">
            <p class="label">Missing these data?</p>
            <div class="tool-button circle-button" (click)="toggleProgressCode()">
                <img src="assets/icons/icon-double-arrow.svg" alt="">
            </div>
        </div>
    </div>
    <!-- Progress Code -->
    <div *ngIf="seeProgressCode" class="popup">
            <div class="horizontal-block">
                <p class="label">Close</p>
                <div class="tool-button circle-button" (click)="toggleProgressCode()">
                    <img src="assets/icons/icon-double-arrow.svg" class="rotate180" alt="">
                </div>
            </div>
            <div class="popup__content">
                <h2>Missing these data?</h2>
                <h3>Continue from this point at a later date</h3>
                <p class="copy">If you do not currently have the required patient data (<i>"{{currentQuestion.question}}”</i>), please make a note of the progress-code below:</p>
                <p class="copy">Progress code:</p>
                <div class="progress-code">
                    <p>{{questionId}}</p>
                    <div class="circle-button circle-button--small circle-button--grey" (click)="copyProgressCode()">
                        <img src="assets/icons/icon-copy.svg" alt="">
                    </div>
                </div>
                <p class="copy">You can use this code to continue this screening from this position at a later date</p>
            </div>
    </div>
    <!-- Snackbar -->
    <div class="snackbar" #snackbar>
        <p>Progress-code copied to your clipboard</p>
    </div>
</div>
